import type { FC } from "react";
import {
  Analytics01Icon,
  DashboardSquare01Icon,
  UserMultiple02Icon
} from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import type { IconSvgElement } from "@hugeicons/react";
import type { OwnerReportSettings } from "api/owner-report-settings";
import { reportScope } from "./helpers";

const Tile: FC<{ icon: IconSvgElement; title: string; detail: string }> = ({
  icon,
  title,
  detail
}) => (
  <div className="flex flex-1 items-center gap-3 rounded-lg border border-alpha-40 px-4 py-3">
    <HugeiconsIcon icon={icon} size={20} className="text-primary-500" />
    <div className="flex flex-col">
      <span className="text-sm font-medium text-content-1000">{title}</span>
      <span className="text-xs text-content-400">{detail}</span>
    </div>
  </div>
);

/**
 * What this partner's owner report contains, so the sender knows what they are
 * about to disclose without opening the setup page. The counts are the partner's
 * configuration, not this application — hence the "Your company's owner report"
 * label beside the heading.
 */
export const ReportScopeTiles: FC<{ settings: OwnerReportSettings }> = ({
  settings
}) => {
  const scope = reportScope(settings);

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-baseline justify-between gap-2">
        <span className="text-sm font-medium text-content-1000">
          What owners will see
        </span>
        <span className="text-xs text-content-400">
          Your company&apos;s owner report
        </span>
      </div>
      <div className="flex flex-wrap gap-3">
        <Tile
          icon={Analytics01Icon}
          title="Summary"
          detail={`${scope.totals} totals`}
        />
        <Tile
          icon={UserMultiple02Icon}
          title="People"
          detail={`${scope.people} included`}
        />
        <Tile
          icon={DashboardSquare01Icon}
          title="Per person"
          detail={`${scope.sections} sections`}
        />
      </div>
    </div>
  );
};
